import { DiagnosticFunnel } from '../../../components/tools/DiagnosticFunnel';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('collectivites', 'diagnostic-cee')!;

export default function CollectivitesDiagnosticCeePage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/collectivites"
        backLabel="Espace collectivités"
        duration="60 sec"
      >
        <DiagnosticFunnel lockedAudience="collectivites" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace collectivités', url: 'https://solutionecofrance.fr/collectivites' },
          { name: 'Diagnostic CEE', url: 'https://solutionecofrance.fr/collectivites/diagnostic-cee' },
        ]}
      />
    </>
  );
}
